import { render, staticRenderFns } from "./ContactPopup.vue?vue&type=template&id=2b561f26&scoped=true"
import script from "./ContactPopup.vue?vue&type=script&lang=js"
export * from "./ContactPopup.vue?vue&type=script&lang=js"
import style0 from "./ContactPopup.vue?vue&type=style&index=0&id=2b561f26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b561f26",
  null
  
)

export default component.exports